import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';

/**
 * Wraps public/marketing/auth routes (`/`, `/login`, `/signup`). A signed-in
 * user with a resolved role is redirected to their app so they never land on
 * the login/signup forms or the marketing page while authenticated.
 *
 * Incomplete profiles are sent to onboarding; RoleRoute enforces the same, so
 * either redirect target lands the user in the right place.
 */
const GuestRoute: React.FC = () => {
  const { currentUser, userRole, profileComplete } = useAuth();

  if (currentUser && userRole) {
    if (!profileComplete) {
      return (
        <Navigate
          to={userRole === 'landlord' ? '/landlord/onboarding' : '/tenant/onboarding'}
          replace
        />
      );
    }
    return (
      <Navigate
        to={userRole === 'landlord' ? '/landlord/dashboard' : '/tenant/swipe'}
        replace
      />
    );
  }

  return <Outlet />;
};

export default GuestRoute;
